import React from 'react';
import * as S from './Tabs.styles';

import {seatTabConfig} from './../../../../../containers/SeatLayout/helpers/config'
const BusDetailedTabs = (props) => {
    const {selectedTab,onTabSelect} = props;
    return(
    <S.TabsWrap>
        {getDetailTabView(seatTabConfig,selectedTab,onTabSelect)}
    </S.TabsWrap>
);
    }

export default BusDetailedTabs;
function getDetailTabView(config,selectedTab,onTabSelect){
    const view =[];
for(let key in config){
    if(config.hasOwnProperty(key)){
     view.push(<S.Tabs key={key+Date.now()} className={`${key === selectedTab ? 'active':''}`}><S.SpanTabs data-val={key} onClick={onTabSelect}>{config[key]}</S.SpanTabs></S.Tabs>);
    }
};
return view;
}